import "@curtin/feature-tour/styles.css";
export * from '@curtin/feature-tour';
